import { render, staticRenderFns } from "./move-branch.vue?vue&type=template&id=9e419178&"
import script from "./move-branch.vue?vue&type=script&lang=js&"
export * from "./move-branch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports